import { axios, handleApiErrors } from '../helpers'

export default (username) => {
  const params = { username }

  return axios
    .request({
      url: 'person/pwd_restore',
      method: 'POST',
      params
    })
    .then(handleApiErrors)
}
